module.exports = __webpack_public_path__ + "static/media/logo_light.8c4c9a89.png";